import React from "react";

const Github = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.0001 22.9999C15.4001 22.9999 15.0001 22.5999 15.0001 21.9999V18.0999C15.1001 17.2999 14.8001 16.6999 14.3001 16.1999C14.0001 15.8999 13.9001 15.4999 14.1001 15.1999C14.2001 14.7999 14.6001 14.5999 14.9001 14.4999C17.8001 14.1999 20.5001 13.1999 20.5001 8.4999C20.5001 7.3999 20.1001 6.2999 19.3001 5.3999C19.0001 5.0999 19.0001 4.6999 19.1001 4.3999C19.4001 3.5999 19.4001 2.7999 19.2001 1.9999C18.7001 2.0999 17.9001 2.3999 16.6001 3.2999C16.4001 3.4999 16.1001 3.4999 15.8001 3.3999C13.7001 2.7999 11.4001 2.7999 9.30011 3.3999C9.00011 3.4999 8.70011 3.4999 8.40011 3.2999C7.20011 2.3999 6.30011 2.0999 5.80011 1.9999C5.60011 2.7999 5.60011 3.5999 5.90011 4.3999C6.00011 4.7999 6.00011 5.1999 5.70011 5.3999C4.90011 6.2999 4.50011 7.3999 4.50011 8.4999C4.50011 13.1999 7.20011 14.1999 10.1001 14.4999C10.5001 14.4999 10.8001 14.7999 10.9001 15.1999C11.0001 15.5999 10.9001 15.9999 10.7001 16.1999C10.2001 16.6999 10.0001 17.2999 10.0001 17.9999V18.8999V18.9999V21.8999C10.0001 22.4999 9.60011 22.8999 9.00011 22.8999C8.40011 22.8999 8.00011 22.4999 8.00011 21.8999V20.1999C5.00011 20.6999 3.70011 18.9999 2.80011 17.8999C2.40011 17.3999 2.10011 16.9999 1.70011 16.8999C1.20011 16.7999 0.800106 16.1999 1.00011 15.6999C1.10011 15.1999 1.70011 14.7999 2.20011 14.9999C3.20011 15.2999 3.80011 15.9999 4.40011 16.6999C5.20011 17.7999 5.90011 18.5999 8.00011 18.1999V18.0999C8.00011 17.4999 8.10011 16.7999 8.30011 16.2999C5.50011 15.6999 2.50011 13.8999 2.50011 8.5999C2.50011 7.0999 3.00011 5.6999 3.90011 4.5999C3.50011 3.1999 3.60011 1.8999 4.20011 0.599896C4.30011 0.299896 4.50011 0.0998964 4.80011 -0.000103645C5.20011 -0.100104 6.50011 -0.300104 9.20011 1.3999C11.4001 0.899896 13.7001 0.899896 15.8001 1.3999C18.4001 -0.300104 19.8001 -0.100104 20.2001 -0.000103645C20.5001 0.0998964 20.7001 0.299896 20.8001 0.599896C21.3001 1.8999 21.4001 3.1999 21.1001 4.4999C22.0001 5.5999 22.5001 6.9999 22.5001 8.4999C22.5001 14.1999 19.1001 15.6999 16.7001 16.2999C16.9001 16.8999 17.0001 17.5999 17.0001 18.1999V21.9999C17.0001 22.5999 16.6001 22.9999 16.0001 22.9999Z" />
  </svg>
);

const Cart = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 21C7 19.8954 7.89543 19 9 19C10.1046 19 11 19.8954 11 21C11 22.1046 10.1046 23 9 23C7.89543 23 7 22.1046 7 21Z" />
    <path d="M18 21C18 19.8954 18.8954 19 20 19C21.1046 19 22 19.8954 22 21C22 22.1046 21.1046 23 20 23C18.8954 23 18 22.1046 18 21Z" />
    <path d="M0 1C0 0.447715 0.447715 0 1 0H5C5.47663 0 5.88701 0.336385 5.98055 0.803743L6.82043 5H23C23.298 5 23.5805 5.13293 23.7705 5.36256C23.9605 5.59218 24.0381 5.89458 23.9823 6.18733L22.3809 14.5848C22.2437 15.2754 21.868 15.8958 21.3195 16.3373C20.7738 16.7766 20.0916 17.011 19.3914 17H9.68864C8.98837 17.011 8.3062 16.7766 7.76048 16.3373C7.21225 15.8959 6.83664 15.2759 6.69933 14.5857C6.69927 14.5854 6.69939 14.5859 6.69933 14.5857L5.02879 6.2392C5.02201 6.21159 5.01638 6.18353 5.01195 6.15508L4.18032 2H1C0.447715 2 0 1.55228 0 1ZM7.22073 7L8.66084 14.1952C8.70656 14.4254 8.83179 14.6322 9.01461 14.7793C9.19743 14.9265 9.42619 15.0047 9.66084 15.0002L9.68 15H19.4L19.4192 15.0002C19.6538 15.0047 19.8826 14.9265 20.0654 14.7793C20.2474 14.6328 20.3723 14.4273 20.4185 14.1984L21.7913 7H7.22073Z" />
  </svg>
);

const Globe = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 2.12501C4.97919 2.12501 2.125 4.97919 2.125 8.50001C2.125 12.0208 4.97919 14.875 8.5 14.875C12.0208 14.875 14.875 12.0208 14.875 8.50001C14.875 4.97919 12.0208 2.12501 8.5 2.12501ZM0.708334 8.50001C0.708334 4.19679 4.19678 0.708344 8.5 0.708344C12.8032 0.708344 16.2917 4.19679 16.2917 8.50001C16.2917 12.8032 12.8032 16.2917 8.5 16.2917C4.19678 16.2917 0.708334 12.8032 0.708334 8.50001Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.708334 8.50001C0.708334 8.10881 1.02547 7.79168 1.41667 7.79168H15.5833C15.9745 7.79168 16.2917 8.10881 16.2917 8.50001C16.2917 8.89121 15.9745 9.20834 15.5833 9.20834H1.41667C1.02547 9.20834 0.708334 8.89121 0.708334 8.50001Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37517 8.50001C6.42371 10.678 7.17276 12.7749 8.5 14.4849C9.82723 12.7749 10.5763 10.678 10.6248 8.50001C10.5763 6.322 9.82724 4.22511 8.5 2.51516C7.17276 4.22511 6.42371 6.322 6.37517 8.50001ZM8.5 1.41668L7.97701 0.938961C6.08947 3.0054 5.01678 5.68712 4.95849 8.48526C4.95828 8.49509 4.95828 8.50493 4.95849 8.51476C5.01678 11.3129 6.08947 13.9946 7.97701 16.0611C8.11121 16.208 8.30101 16.2917 8.5 16.2917C8.69899 16.2917 8.88879 16.208 9.02299 16.0611C10.9105 13.9946 11.9832 11.3129 12.0415 8.51476C12.0417 8.50493 12.0417 8.49509 12.0415 8.48526C11.9832 5.68712 10.9105 3.0054 9.02299 0.938961L8.5 1.41668Z"
    />
  </svg>
);

const Check = ({ size = 18 }) => (
  <svg
    width={size}
    className="slr"
    height={size}
    viewBox="0 0 22 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9815 4.85174C19.3395 5.20972 19.3395 5.79012 18.9815 6.1481L8.89818 16.2314C8.5402 16.5894 7.9598 16.5894 7.60182 16.2314L3.01849 11.6481C2.6605 11.2901 2.6605 10.7097 3.01849 10.3517C3.37647 9.99376 3.95687 9.99376 4.31485 10.3517L8.25 14.2869L17.6852 4.85174C18.0431 4.49376 18.6235 4.49376 18.9815 4.85174Z"
    />
  </svg>
);

const Trash = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 3.75C1.25 3.40482 1.52982 3.125 1.875 3.125H13.125C13.4702 3.125 13.75 3.40482 13.75 3.75C13.75 4.09518 13.4702 4.375 13.125 4.375H1.875C1.52982 4.375 1.25 4.09518 1.25 3.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 1.875C6.08424 1.875 5.92527 1.94085 5.80806 2.05806C5.69085 2.17527 5.625 2.33424 5.625 2.5V3.125H9.375V2.5C9.375 2.33424 9.30915 2.17527 9.19194 2.05806C9.07473 1.94085 8.91576 1.875 8.75 1.875H6.25ZM10.625 3.125V2.5C10.625 2.00272 10.4275 1.52581 10.0758 1.17417C9.72419 0.822544 9.24728 0.625 8.75 0.625H6.25C5.75272 0.625 5.27581 0.822544 4.92418 1.17417C4.57254 1.52581 4.375 2.00272 4.375 2.5V3.125H3.125C2.77982 3.125 2.5 3.40482 2.5 3.75V12.5C2.5 12.9973 2.69754 13.4742 3.04917 13.8258C3.40081 14.1775 3.87772 14.375 4.375 14.375H10.625C11.1223 14.375 11.5992 14.1775 11.9508 13.8258C12.3025 13.4742 12.5 12.9973 12.5 12.5V3.75C12.5 3.40482 12.2202 3.125 11.875 3.125H10.625ZM3.75 4.375V12.5C3.75 12.6658 3.81585 12.8247 3.93306 12.9419C4.05027 13.0592 4.20924 13.125 4.375 13.125H10.625C10.7908 13.125 10.9497 13.0592 11.0669 12.9419C11.1842 12.8247 11.25 12.6658 11.25 12.5V4.375H3.75Z"
    />
  </svg>
);

const Eye = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 23 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5 0C7.3 0 4.02 2.5 0 6.57c3.46 3.48 6.37 6.57 11.5 6.57s8.9-3.92 11.5-6.5C20.34 3.62 16.57 0 11.5 0Zm0 11.26c-2.54 0-4.6-2.1-4.6-4.69a4.65 4.65 0 0 1 4.6-4.69c2.54 0 4.6 2.1 4.6 4.7a4.65 4.65 0 0 1-4.6 4.68Z" />
    <path d="M11.5 4.93c0-.4.15-.78.39-1.06a2.72 2.72 0 0 0-3.08 2.7c0 1.51 1.21 2.74 2.69 2.74a2.72 2.72 0 0 0 2.66-3.1 1.64 1.64 0 0 1-2.66-1.28Z" />
  </svg>
);

const Code = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L16.7071 18.7071C16.3166 19.0976 15.6834 19.0976 15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929L20.5858 12L15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289Z" />
    <path d="M8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L3.41421 12L8.70711 17.2929C9.09763 17.6834 9.09763 18.3166 8.70711 18.7071C8.31658 19.0976 7.68342 19.0976 7.29289 18.7071L1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289Z" />
  </svg>
);

const Question = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" />
    <path d="M12.3561 8.5601C11.8705 8.58141 11.6116 8.77678 11.5219 8.96723C11.2867 9.46693 10.691 9.68137 10.1913 9.44618C9.69158 9.211 9.47715 8.61525 9.71233 8.11554C10.2345 7.00604 11.3595 6.60191 12.2684 6.56202C13.1427 6.52365 14.2308 6.80214 14.8327 7.5871C15.2959 8.19115 15.5562 8.95686 15.4511 9.76195C15.3445 10.5783 14.8789 11.3106 14.1233 11.8664C13.1144 12.6087 13.1162 12.9874 13.1165 13.0425C13.1165 13.0433 13.1165 13.0441 13.1165 13.0447C13.1165 13.597 12.6688 14.0447 12.1165 14.0447C11.5642 14.0447 11.1165 13.597 11.1165 13.0447C11.1165 12.088 11.6729 11.1862 12.9382 10.2554C13.3271 9.96932 13.4428 9.69557 13.4679 9.50308C13.4945 9.29933 13.4368 9.05335 13.2457 8.80415C13.2322 8.78663 13.1592 8.71368 12.9763 8.64796C12.8017 8.5852 12.5821 8.55018 12.3561 8.5601Z" />
    <path d="M12 23C5.9 23 1 18.1 1 12C1 5.9 5.9 1 12 1C18.1 1 23 5.9 23 12C23 18.1 18.1 23 12 23ZM12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3Z" />
  </svg>
);

const Twitter = ({ size = 18 }) => (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.928 2.24729C20.1553 2.61442 19.3262 2.85347 18.465 2.96446C19.3504 2.40097 20.0346 1.51305 20.3485 0.445833C19.5194 0.966634 18.6018 1.34229 17.6198 1.55574C16.839 0.667814 15.7202 0.121399 14.4886 0.121399C12.1141 0.121399 10.1984 2.16192 10.1984 4.67201C10.1984 5.03059 10.2386 5.38064 10.3111 5.71361C6.73722 5.51724 3.57386 3.69871 1.45691 0.949559C1.08665 1.62404 0.877367 2.40097 0.877367 3.23767C0.877367 4.81715 1.634 6.2088 2.78504 7.02842C2.08475 7.00281 1.41667 6.7979 0.837121 6.4564V6.51616C0.837121 8.72743 2.31818 10.563 4.2822 10.9814C3.91998 11.0838 3.54167 11.1436 3.14725 11.1436C2.87358 11.1436 2.59991 11.118 2.34233 11.0668C2.88968 12.8768 4.47538 14.1916 6.35085 14.2257C4.88589 15.4466 3.03456 16.1723 1.02225 16.1723C0.676136 16.1723 0.330019 16.1553 0 16.104C1.89962 17.3932 4.15341 18.1531 6.58428 18.1531C14.4806 18.1531 18.803 11.2119 18.803 5.19281C18.803 4.99644 18.803 4.80008 18.795 4.60371C19.6321 3.96338 20.3646 3.16083 20.9361 2.24729H20.928Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Award = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.75 1.25C5.67893 1.25 4 2.92893 4 5C4 7.07107 5.67893 8.75 7.75 8.75C9.82107 8.75 11.5 7.07107 11.5 5C11.5 2.92893 9.82107 1.25 7.75 1.25ZM2.75 5C2.75 2.23858 4.98858 0 7.75 0C10.5114 0 12.75 2.23858 12.75 5C12.75 7.76142 10.5114 10 7.75 10C4.98858 10 2.75 7.76142 2.75 5Z" />
    <path d="M10.0366 8.05543C10.3787 8.01003 10.6929 8.25062 10.7383 8.5928L11.4946 14.2928C11.5261 14.5307 11.4187 14.7657 11.2181 14.8974C11.0175 15.0291 10.7592 15.0344 10.5535 14.9109L7.75002 13.2289L4.94657 14.9109C4.74078 15.0344 4.48246 15.0291 4.28187 14.8974C4.08128 14.7656 3.97386 14.5306 4.00546 14.2927L4.76171 8.59896C4.80715 8.25679 5.12138 8.01624 5.46356 8.06169C5.80573 8.10714 6.04627 8.42137 6.00082 8.76354L5.41529 13.172L7.42846 11.9641C7.62638 11.8453 7.87365 11.8453 8.07158 11.9641L10.0849 13.1721L9.49919 8.7572C9.4538 8.41502 9.69438 8.10083 10.0366 8.05543Z" />
  </svg>
);

const Facebook = ({ size = 18 }) => (
  <svg
    width="12"
    height="24"
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.80308 5.89338V8.55618H11.869L11.3322 12.7046H7.80308V23.3351H3.55223V12.6891H0V8.55618H3.55223V5.48372C3.55223 1.93419 5.70462 -3.2414e-05 8.83048 -3.2414e-05C9.88911 -0.00264592 10.9471 0.0518806 12 0.163313V3.8736H9.83733C8.12671 3.8736 7.80308 4.69292 7.80308 5.89338Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Email = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="14.766"
    viewBox="0 0 21 14.766"
  >
    <g id="email" transform="translate(0 -76)">
      <g
        id="Group_2439"
        data-name="Group 2439"
        transform="translate(1.076 84.254)"
      >
        <g id="Group_2438" data-name="Group 2438">
          <path
            id="Path_1484"
            data-name="Path 1484"
            d="M38.758,277.251,37,279.016a1.947,1.947,0,0,1-2.7,0l-1.759-1.765-6.317,6.338a1.828,1.828,0,0,0,.77.174H44.3a1.826,1.826,0,0,0,.77-.174Z"
            transform="translate(-26.226 -277.251)"
            fill="#a0a0a0"
          />
        </g>
      </g>
      <g id="Group_2441" data-name="Group 2441" transform="translate(1.076 76)">
        <g id="Group_2440" data-name="Group 2440">
          <path
            id="Path_1485"
            data-name="Path 1485"
            d="M44.307,76H27a1.827,1.827,0,0,0-.77.174l6.75,6.773h0l2.195,2.2a.739.739,0,0,0,.954,0l2.194-2.2h0l6.75-6.773A1.826,1.826,0,0,0,44.307,76Z"
            transform="translate(-26.228 -76)"
            fill="#a0a0a0"
          />
        </g>
      </g>
      <g id="Group_2443" data-name="Group 2443" transform="translate(0 77.034)">
        <g id="Group_2442" data-name="Group 2442">
          <path
            id="Path_1486"
            data-name="Path 1486"
            d="M.2,101.212a1.823,1.823,0,0,0-.2.812V113.1a1.822,1.822,0,0,0,.2.812l6.328-6.349Z"
            transform="translate(0 -101.212)"
            fill="#a0a0a0"
          />
        </g>
      </g>
      <g
        id="Group_2445"
        data-name="Group 2445"
        transform="translate(14.476 77.034)"
      >
        <g id="Group_2444" data-name="Group 2444">
          <path
            id="Path_1487"
            data-name="Path 1487"
            d="M359.261,101.21l-6.328,6.349,6.328,6.349a1.823,1.823,0,0,0,.2-.812V102.022A1.823,1.823,0,0,0,359.261,101.21Z"
            transform="translate(-352.933 -101.21)"
            fill="#a0a0a0"
          />
        </g>
      </g>
    </g>
  </svg>
);

const Link = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.51691 1.83378C9.27132 1.10515 10.2817 0.701975 11.3305 0.711089C12.3793 0.720202 13.3826 1.14088 14.1242 1.88251C14.8658 2.62414 15.2865 3.62739 15.2956 4.67618C15.3047 5.72497 14.9015 6.73538 14.1729 7.48979L14.1648 7.49805L12.1649 9.49796C11.7594 9.90362 11.2714 10.2173 10.734 10.4178C10.1965 10.6183 9.62231 10.7008 9.0502 10.6598C8.47808 10.6189 7.92147 10.4553 7.41812 10.1803C6.91476 9.90531 6.47644 9.52527 6.13287 9.06596C5.91234 8.77113 5.97257 8.35334 6.2674 8.1328C6.56223 7.91226 6.98002 7.97249 7.20056 8.26732C7.4296 8.57353 7.72182 8.82689 8.05739 9.01023C8.39296 9.19356 8.76403 9.30259 9.14544 9.3299C9.52685 9.35722 9.90967 9.30219 10.2679 9.16854C10.6262 9.0349 10.9516 8.82576 11.2219 8.55532L13.2177 6.55956C13.701 6.05705 13.9684 5.38513 13.9623 4.68777C13.9562 3.98857 13.6758 3.31974 13.1814 2.82532C12.687 2.3309 12.0181 2.05045 11.3189 2.04437C10.6213 2.03831 9.94906 2.30591 9.44648 2.78967L8.30341 3.92609C8.04231 4.18568 7.6202 4.18445 7.36061 3.92334C7.10102 3.66223 7.10225 3.24012 7.36336 2.98053L8.51002 1.84053L8.51691 1.83378Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.26615 5.58217C5.80356 5.3817 6.37779 5.29915 6.94991 5.34012C7.52202 5.3811 8.07863 5.54463 8.58199 5.81964C9.08534 6.09465 9.52367 6.47469 9.86723 6.93399C10.0878 7.22882 10.0275 7.64662 9.7327 7.86715C9.43787 8.08769 9.02008 8.02746 8.79954 7.73263C8.5705 7.42643 8.27828 7.17307 7.94271 6.98973C7.60715 6.80639 7.23607 6.69737 6.85466 6.67005C6.47325 6.64274 6.09043 6.69777 5.73216 6.83141C5.37389 6.96506 5.04855 7.17419 4.77821 7.44463L2.78245 9.44039C2.29909 9.94291 2.03172 10.6148 2.03778 11.3122C2.04386 12.0114 2.32431 12.6802 2.81873 13.1746C3.31315 13.6691 3.98198 13.9495 4.68117 13.9556C5.37854 13.9616 6.05045 13.6943 6.55296 13.2109L7.68865 12.0752C7.949 11.8149 8.37111 11.8149 8.63146 12.0752C8.89181 12.3356 8.89181 12.7577 8.63146 13.018L7.49146 14.158L7.48319 14.1662C6.72878 14.8948 5.71838 15.298 4.66959 15.2889C3.6208 15.2798 2.61755 14.8591 1.87592 14.1174C1.13429 13.3758 0.713611 12.3726 0.704497 11.3238C0.695383 10.275 1.09856 9.26458 1.82719 8.51017L1.83531 8.50191L3.83523 6.50199C3.8352 6.50202 3.83526 6.50196 3.83523 6.50199C4.24072 6.09638 4.72878 5.78262 5.26615 5.58217Z"
      fill="black"
    />
  </svg>
);

const linkdnLversion = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    id="meteor-icon-kit__regular-linkedin"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.37214 24H0.396429V7.97674H5.37214V24ZM2.88161 5.79102C1.29054 5.79102 0 4.47317 0 2.8821C2.37147e-08 1.29063 1.29014 0.000488281 2.88161 0.000488281C4.47307 0.000488281 5.76321 1.29063 5.76321 2.8821C5.76321 4.47317 4.47214 5.79102 2.88161 5.79102ZM23.9946 24H19.0296V16.2C19.0296 14.341 18.9921 11.9571 16.4427 11.9571C13.8557 11.9571 13.4593 13.9767 13.4593 16.066V24H8.48893V7.97674H13.2611V10.1625H13.3307C13.995 8.90352 15.6177 7.57495 18.0386 7.57495C23.0743 7.57495 24 10.891 24 15.1982V24H23.9946Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Linkedin = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 01-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 002 2.866v10.268a.88.88 0 00.885.866h10.226a.882.882 0 00.889-.866V2.865a.88.88 0 00-.889-.864z" />
  </svg>
);

const Google = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.545,12.151L12.545,12.151c0,1.054,0.855,1.909,1.909,1.909h3.536c-0.607,1.972-2.101,3.467-4.26,3.866 c-3.431,0.635-6.862-1.865-7.19-5.339c-0.34-3.595,2.479-6.62,6.005-6.62c1.002,0,1.946,0.246,2.777,0.679 c0.757,0.395,1.683,0.236,2.286-0.368l0,0c0.954-0.954,0.701-2.563-0.498-3.179c-1.678-0.862-3.631-1.264-5.692-1.038 c-4.583,0.502-8.31,4.226-8.812,8.809C1.945,16.9,6.649,22,12.545,22c6.368,0,8.972-4.515,9.499-8.398 c0.242-1.78-1.182-3.352-2.978-3.354l-4.61-0.006C13.401,10.24,12.545,11.095,12.545,12.151z" />
  </svg>
);

const Signin = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      clipRule="evenodd"
      d="M24,45C12.402,45,3,35.598,3,24S12.402,3,24,3s21,9.402,21,21S35.598,45,24,45z   M35.633,39c-0.157-0.231-0.355-0.518-0.514-0.742c-0.277-0.394-0.554-0.788-0.802-1.178C34.305,37.062,32.935,35.224,28,35  c-1.717,0-2.965-1.288-2.968-3.066L25,31c0-0.135-0.016,0.148,0,0v-1l1-1c0.731-0.339,1.66-0.909,2.395-1.464l0.135-0.093  C29.111,27.074,29.923,26.297,30,26l0.036-0.381C30.409,23.696,31,20.198,31,19c0-4.71-2.29-7-7-7c-4.775,0-7,2.224-7,7  c0,1.23,0.591,4.711,0.963,6.616l0.035,0.352c0.063,0.313,0.799,1.054,1.449,1.462l0.098,0.062C20.333,28.043,21.275,28.657,22,29  l1,1v1c0.014,0.138,0-0.146,0,0l-0.033,0.934c0,1.775-1.246,3.064-2.883,3.064c-0.001,0-0.002,0-0.003,0  c-4.956,0.201-6.393,2.077-6.395,2.077c-0.252,0.396-0.528,0.789-0.807,1.184c-0.157,0.224-0.355,0.51-0.513,0.741  c3.217,2.498,7.245,4,11.633,4S32.416,41.498,35.633,39z M24,5C13.507,5,5,13.507,5,24c0,5.386,2.25,10.237,5.85,13.694  C11.232,37.129,11.64,36.565,12,36c0,0,1.67-2.743,8-3c0.645,0,0.967-0.422,0.967-1.066h0.001C20.967,31.413,20.967,31,20.967,31  c0-0.13-0.021-0.247-0.027-0.373c-0.724-0.342-1.564-0.814-2.539-1.494c0,0-2.4-1.476-2.4-3.133c0,0-1-5.116-1-7  c0-4.644,1.986-9,9-9c6.92,0,9,4.356,9,9c0,1.838-1,7-1,7c0,1.611-2.4,3.133-2.4,3.133c-0.955,0.721-1.801,1.202-2.543,1.546  c-0.005,0.109-0.023,0.209-0.023,0.321c0,0-0.001,0.413-0.001,0.934h0.001C27.033,32.578,27.355,33,28,33c6.424,0.288,8,3,8,3  c0.36,0.565,0.767,1.129,1.149,1.694C40.749,34.237,43,29.386,43,24C43,13.507,34.493,5,24,5z"
      fillRule="evenodd"
    />
  </svg>
);
const Random = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    clipRule="evenodd"
  >
    <path d="M21.67 3.955l-2.825-2.202.665-.753 4.478 3.497-4.474 3.503-.665-.753 2.942-2.292h-4.162c-3.547.043-5.202 3.405-6.913 7.023 1.711 3.617 3.366 6.979 6.913 7.022h4.099l-2.883-2.247.665-.753 4.478 3.497-4.474 3.503-.665-.753 2.884-2.247h-4.11c-3.896-.048-5.784-3.369-7.461-6.858-1.687 3.51-3.592 6.842-7.539 6.858h-2.623v-1h2.621c3.6-.014 5.268-3.387 6.988-7.022-1.72-3.636-3.388-7.009-6.988-7.023h-2.621v-1h2.623c3.947.016 5.852 3.348 7.539 6.858 1.677-3.489 3.565-6.81 7.461-6.858h4.047z" />
  </svg>
);

const Pencil = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.6.21a.73.73 0 0 0-1.03 0L.62 7.15a.27.27 0 0 0-.07.15L.27 8.97 0 10.64a.27.27 0 0 0 .32.31l1.9-.32h.04l1.39-.23c.05-.01.1-.04.14-.08l3.5-3.49.04-.03 3.4-3.4a.64.64 0 0 0 .23-.53.77.77 0 0 0-.22-.51L8.6.2ZM.8 9.17l.98.98 1.68-.28a.3.3 0 0 1-.03-.02L1.07 7.48.82 9.06l-.02.1Zm.73-2.15L3.9 9.38a.3.3 0 0 1 .02.03L6.9 6.44h.01l.03-.03 2.13-2.13a.3.3 0 0 1-.02-.01L6.67 1.89 1.53 7.02Zm8.89-4.13c0 .05-.02.07-.04.08l-.03.03-.82.82a.3.3 0 0 0-.02-.02L7.13 1.42 7.96.6a.18.18 0 0 1 .25 0l2.14 2.14c.04.04.06.1.07.15Z"
    />
  </svg>
);
const Crop = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 16H6a2 2 0 0 1-2-2V6H0V4h4V0h2v14h14v2h-4v4h-2v-4zm0-3V6H7V4h7a2 2 0 0 1 2 2v7h-2z" />
  </svg>
);

const Meettheteamlinkdn = ({ size = 18 }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.93809 1.55625C2.9379 1.96878 2.78293 2.36434 2.5073 2.6559C2.23166 2.94746 1.85793 3.11115 1.46831 3.11094C1.0787 3.11073 0.705116 2.94666 0.429754 2.6548C0.154392 2.36295 -0.000194624 1.96723 1.83896e-07 1.55469C0.000194991 1.14216 0.155156 0.746598 0.430793 0.455036C0.70643 0.163475 1.08016 -0.000206073 1.46978 1.94715e-07C1.85939 0.000206463 2.23298 0.164284 2.50834 0.456136C2.7837 0.747989 2.93829 1.14371 2.93809 1.55625ZM2.98216 4.26276H0.0440715V14H2.98216V4.26276ZM7.62434 4.26276H4.70094V14H7.59496V8.89028C7.59496 6.04378 11.0986 5.77935 11.0986 8.89028V14H14V7.83256C14 3.03394 8.81427 3.21282 7.59496 5.56936L7.62434 4.26276Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Meettheteaminstagram = ({ size = 18 }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16821 0.5C7.89942 0.50195 8.27055 0.50585 8.59099 0.51495L8.71708 0.5195C8.86267 0.524699 9.00631 0.531199 9.17985 0.538999C9.87142 0.571498 10.3433 0.680696 10.7573 0.841242C11.1863 1.00634 11.5477 1.22993 11.9091 1.59067C12.2396 1.9156 12.4953 2.30864 12.6585 2.74245C12.819 3.15649 12.9282 3.62838 12.9607 4.32061C12.9685 4.49351 12.975 4.63715 12.9802 4.7834L12.9841 4.9095C12.9939 5.22929 12.9978 5.60043 12.9991 6.33166L12.9997 6.81655V7.66803C13.0013 8.14213 12.9963 8.61624 12.9848 9.0902L12.9809 9.2163C12.9757 9.36254 12.9692 9.50619 12.9614 9.67909C12.9289 10.3713 12.8184 10.8426 12.6585 11.2572C12.4958 11.6913 12.24 12.0844 11.9091 12.409C11.5841 12.7394 11.1911 12.9951 10.7573 13.1585C10.3433 13.319 9.87142 13.4282 9.17985 13.4607C9.02563 13.468 8.87137 13.4745 8.71708 13.4802L8.59099 13.4841C8.27055 13.4932 7.89942 13.4977 7.16821 13.499L6.68333 13.4997H5.83253C5.35822 13.5013 4.88392 13.4963 4.40975 13.4847L4.28366 13.4808C4.12936 13.475 3.9751 13.4683 3.82088 13.4607C3.12931 13.4282 2.65744 13.319 2.24276 13.1585C1.80902 12.9956 1.41614 12.7398 1.09167 12.409C0.760866 12.0842 0.504895 11.6912 0.341608 11.2572C0.181066 10.8432 0.0718713 10.3713 0.039373 9.67909C0.0321316 9.52485 0.0256319 9.37059 0.019874 9.2163L0.0166243 9.0902C0.0046467 8.61624 -0.000770265 8.14214 0.000375031 7.66803V6.33166C-0.001439 5.85756 0.00332793 5.38346 0.0146743 4.9095L0.0192241 4.7834C0.0244238 4.63715 0.0309235 4.49351 0.0387231 4.32061C0.0712214 3.62838 0.180416 3.15714 0.340958 2.74245C0.504173 2.3082 0.760654 1.91503 1.09232 1.59067C1.41671 1.26014 1.80933 1.00438 2.24276 0.841242C2.65744 0.680696 3.12866 0.571498 3.82088 0.538999C3.99377 0.531199 4.13806 0.524699 4.28366 0.5195L4.40975 0.5156C4.8837 0.504051 5.35779 0.499067 5.83188 0.50065L7.16821 0.5ZM6.50004 3.74992C5.63813 3.74992 4.81152 4.09233 4.20206 4.70181C3.5926 5.31128 3.25021 6.13791 3.25021 6.99985C3.25021 7.86178 3.5926 8.68841 4.20206 9.29789C4.81152 9.90737 5.63813 10.2498 6.50004 10.2498C7.36195 10.2498 8.18856 9.90737 8.79802 9.29789C9.40748 8.68841 9.74988 7.86178 9.74988 6.99985C9.74988 6.13791 9.40748 5.31128 8.79802 4.70181C8.18856 4.09233 7.36195 3.74992 6.50004 3.74992ZM6.50004 5.04989C6.75611 5.04985 7.00967 5.10025 7.24626 5.1982C7.48285 5.29616 7.69783 5.43975 7.87892 5.62079C8.06002 5.80183 8.20368 6.01677 8.30172 6.25333C8.39975 6.4899 8.45022 6.74345 8.45027 6.99952C8.45031 7.2556 8.39992 7.50917 8.30196 7.74576C8.20401 7.98236 8.06042 8.19734 7.87938 8.37844C7.69835 8.55954 7.48342 8.70321 7.24686 8.80125C7.01031 8.89928 6.75676 8.94976 6.50069 8.9498C5.98355 8.9498 5.48758 8.74436 5.1219 8.37867C4.75623 8.01299 4.55079 7.51701 4.55079 6.99985C4.55079 6.48269 4.75623 5.98671 5.1219 5.62102C5.48758 5.25533 5.98355 5.04989 6.50069 5.04989M9.91302 2.77495C9.69754 2.77495 9.49089 2.86055 9.33852 3.01292C9.18616 3.16529 9.10056 3.37194 9.10056 3.58743C9.10056 3.80291 9.18616 4.00957 9.33852 4.16194C9.49089 4.31431 9.69754 4.39991 9.91302 4.39991C10.1285 4.39991 10.3351 4.31431 10.4875 4.16194C10.6399 4.00957 10.7255 3.80291 10.7255 3.58743C10.7255 3.37194 10.6399 3.16529 10.4875 3.01292C10.3351 2.86055 10.1285 2.77495 9.91302 2.77495Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Meettheteamtwitter = ({ size = 18 }) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.238 0H12.2314L7.87638 5.08367L13 12H8.98842L5.84675 7.80473L2.25117 12H0.25675L4.91508 6.5623L0 0.0005532H4.11342L6.95338 3.83515L10.238 0ZM9.53875 10.7819H10.6432L3.51325 1.15447H2.32808L9.53875 10.7819Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Meettheteamfacebook = ({ size = 18 }) => (
  <svg
    width="7"
    height="14"
    viewBox="0 0 7 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 8.05H6.33333L7 5.25H4.66667V3.85C4.66667 3.129 4.66667 2.45 6 2.45H7V0.0980001C6.78267 0.0679001 5.962 0 5.09533 0C3.28533 0 2 1.1599 2 3.29V5.25H0V8.05H2V14H4.66667V8.05Z"
      fill="#A0A0A0"
    />
  </svg>
);

const Meettheteamsearch = ({ size = 18 }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.125 4.25C2.125 4.1091 2.18097 3.97398 2.2806 3.87435C2.38023 3.77472 2.51535 3.71875 2.65625 3.71875H14.3438C14.4846 3.71875 14.6198 3.77472 14.7194 3.87435C14.819 3.97398 14.875 4.1091 14.875 4.25C14.875 4.3909 14.819 4.52602 14.7194 4.62565C14.6198 4.72528 14.4846 4.78125 14.3438 4.78125H2.65625C2.51535 4.78125 2.38023 4.72528 2.2806 4.62565C2.18097 4.52602 2.125 4.3909 2.125 4.25ZM2.65625 9.03125H7.4375C7.5784 9.03125 7.71352 8.97528 7.81315 8.87565C7.91278 8.77602 7.96875 8.6409 7.96875 8.5C7.96875 8.3591 7.91278 8.22398 7.81315 8.12435C7.71352 8.02472 7.5784 7.96875 7.4375 7.96875H2.65625C2.51535 7.96875 2.38023 8.02472 2.2806 8.12435C2.18097 8.22398 2.125 8.3591 2.125 8.5C2.125 8.6409 2.18097 8.77602 2.2806 8.87565C2.38023 8.97528 2.51535 9.03125 2.65625 9.03125ZM8.5 12.2188H2.65625C2.51535 12.2188 2.38023 12.2747 2.2806 12.3743C2.18097 12.474 2.125 12.6091 2.125 12.75C2.125 12.8909 2.18097 13.026 2.2806 13.1257C2.38023 13.2253 2.51535 13.2812 2.65625 13.2812H8.5C8.6409 13.2812 8.77602 13.2253 8.87565 13.1257C8.97528 13.026 9.03125 12.8909 9.03125 12.75C9.03125 12.6091 8.97528 12.474 8.87565 12.3743C8.77602 12.2747 8.6409 12.2188 8.5 12.2188ZM15.7821 13.1259C15.7328 13.1753 15.6742 13.2144 15.6097 13.2412C15.5452 13.2679 15.4761 13.2817 15.4062 13.2817C15.3364 13.2817 15.2673 13.2679 15.2028 13.2412C15.1383 13.2144 15.0797 13.1753 15.0304 13.1259L13.6797 11.7778C13.1304 12.1402 12.4661 12.2858 11.8156 12.1864C11.1651 12.087 10.5746 11.7496 10.1587 11.2397C9.74268 10.7298 9.53078 10.0837 9.56403 9.42642C9.59728 8.7692 9.87331 8.14771 10.3386 7.68238C10.804 7.21706 11.4254 6.94103 12.0827 6.90778C12.7399 6.87453 13.3861 7.08643 13.896 7.50241C14.4059 7.9184 14.7432 8.50885 14.8427 9.15937C14.9421 9.80989 14.7965 10.4741 14.4341 11.0234L15.7821 12.3715C15.8319 12.4209 15.8714 12.4796 15.8984 12.5444C15.9254 12.6091 15.9393 12.6785 15.9393 12.7487C15.9393 12.8188 15.9254 12.8882 15.8984 12.953C15.8714 13.0177 15.8319 13.0765 15.7821 13.1259ZM12.2188 11.1562C12.534 11.1562 12.8421 11.0628 13.1042 10.8877C13.3663 10.7125 13.5706 10.4636 13.6912 10.1724C13.8118 9.88118 13.8434 9.56073 13.7819 9.25157C13.7204 8.94242 13.5686 8.65844 13.3457 8.43555C13.1228 8.21266 12.8388 8.06087 12.5297 7.99937C12.2205 7.93788 11.9001 7.96944 11.6088 8.09007C11.3176 8.21069 11.0687 8.41497 10.8936 8.67706C10.7185 8.93915 10.625 9.24729 10.625 9.5625C10.625 9.98519 10.7929 10.3906 11.0918 10.6895C11.3907 10.9883 11.7961 11.1562 12.2188 11.1562Z"
      fill="black"
    />
  </svg>
);

const Icons = {
  Meettheteamsearch,
  Meettheteamlinkdn,
  Meettheteaminstagram,
  Meettheteamtwitter,
  Meettheteamfacebook,
  Pencil,
  Github,
  Cart,
  Globe,
  Check,
  Trash,
  Question,
  Eye,
  Code,
  Twitter,
  Award,
  Facebook,
  Email,
  Google,
  Signin,
  Link,
  linkdnLversion,
  Linkedin,
  Random,
  Crop,
  File: ({ size = 18 }) => (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5672 4.55781L9.19219 0.182813C9.1341 0.124791 9.06515 0.0787825 8.98928 0.0474149C8.91341 0.0160474 8.8321 -6.43662e-05 8.75 1.93249e-07L1.25 1.93249e-07C0.918479 1.93249e-07 0.600537 0.131696 0.366116 0.366117C0.131696 0.600537 0 0.91848 0 1.25L0 15C0 15.3315 0.131696 15.6495 0.366116 15.8839C0.600537 16.1183 0.918479 16.25 1.25 16.25L12.5 16.25C12.8315 16.25 13.1495 16.1183 13.3839 15.8839C13.6183 15.6495 13.75 15.3315 13.75 15L13.75 5C13.7501 4.9179 13.734 4.83659 13.7026 4.76072C13.6712 4.68485 13.6252 4.6159 13.5672 4.55781ZM9.375 2.13359L11.6164 4.375H9.375L9.375 2.13359ZM12.5 15L1.25 15L1.25 1.25L8.125 1.25L8.125 5C8.125 5.16576 8.19085 5.32473 8.30806 5.44194C8.42527 5.55915 8.58424 5.625 8.75 5.625L12.5 5.625L12.5 15Z"
        fill="currentColor"
      />
    </svg>
  ),

  Fileup: ({ size = 18 }) => (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5672 4.55781L9.19219 0.182813C9.1341 0.124791 9.06515 0.0787825 8.98928 0.0474149C8.91341 0.0160474 8.8321 -6.43662e-05 8.75 1.93249e-07L1.25 1.93249e-07C0.918479 1.93249e-07 0.600537 0.131696 0.366116 0.366117C0.131696 0.600537 0 0.91848 0 1.25L0 15C0 15.3315 0.131696 15.6495 0.366116 15.8839C0.600537 16.1183 0.918479 16.25 1.25 16.25L12.5 16.25C12.8315 16.25 13.1495 16.1183 13.3839 15.8839C13.6183 15.6495 13.75 15.3315 13.75 15L13.75 5C13.7501 4.9179 13.734 4.83659 13.7026 4.76072C13.6712 4.68485 13.6252 4.6159 13.5672 4.55781ZM9.375 2.13359L11.6164 4.375H9.375L9.375 2.13359ZM12.5 15L1.25 15L1.25 1.25L8.125 1.25L8.125 5C8.125 5.16576 8.19085 5.32473 8.30806 5.44194C8.42527 5.55915 8.58424 5.625 8.75 5.625L12.5 5.625L12.5 15Z"
        fill="white"
      />
    </svg>
  ),

  ChkFile: ({ size = 18 }) => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6156 2.2C17.6156 1.61652 17.8474 1.05695 18.26 0.644365C18.6726 0.231785 19.2321 0 19.8156 0H26.4156C26.9991 0 27.5587 0.231785 27.9713 0.644365C28.3838 1.05695 28.6156 1.61652 28.6156 2.2V11H26.4156V2.2H19.8156V8.8C19.8156 9.38348 19.5838 9.94305 19.1713 10.3556C18.7587 10.7682 18.1991 11 17.6156 11H11.0156V17.6C11.0156 18.1835 10.7838 18.7431 10.3713 19.1556C9.95868 19.5682 9.3991 19.8 8.81563 19.8H2.21563V26.4H11.0156V28.6H2.21563C1.63215 28.6 1.07257 28.3682 0.65999 27.9556C0.24741 27.5431 0.015625 26.9835 0.015625 26.4V19.8C0.015625 19.2165 0.24741 18.6569 0.65999 18.2444C1.07257 17.8318 1.63215 17.6 2.21563 17.6H8.81563V11C8.81563 10.4165 9.04741 9.85695 9.45999 9.44437C9.87257 9.03179 10.4321 8.8 11.0156 8.8H17.6156V2.2ZM24.2156 13.2C23.6321 13.2 23.0726 13.4318 22.66 13.8444C22.2474 14.2569 22.0156 14.8165 22.0156 15.4V22H15.4156C14.8321 22 14.2726 22.2318 13.86 22.6444C13.4474 23.0569 13.2156 23.6165 13.2156 24.2V30.8C13.2156 31.3835 13.4474 31.9431 13.86 32.3556C14.2726 32.7682 14.8321 33 15.4156 33H27.5156C28.9743 33 30.3733 32.4205 31.4047 31.3891C32.4362 30.3576 33.0156 28.9587 33.0156 27.5V15.4C33.0156 14.8165 32.7838 14.2569 32.3713 13.8444C31.9587 13.4318 31.3991 13.2 30.8156 13.2H24.2156ZM24.2156 15.4H30.8156V27.5C30.8156 28.3752 30.4679 29.2146 29.8491 29.8335C29.2302 30.4523 28.3908 30.8 27.5156 30.8H15.4156V24.2H22.0156C22.5991 24.2 23.1587 23.9682 23.5713 23.5556C23.9838 23.1431 24.2156 22.5835 24.2156 22V15.4Z"
        fill="black"
      />
    </svg>
  ),

  ChkOrg: ({ size = 18 }) => (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4V0H0V18H20V4H10ZM8 16H2V14H8V16ZM8 12H2V10H8V12ZM8 8H2V6H8V8ZM8 4H2V2H8V4ZM18 16H10V6H18V16ZM16 8H12V10H16V8ZM16 12H12V14H16V12Z"
        fill="black"
      />
    </svg>
  ),

  Chksup: ({ size = 18 }) => (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4480_10718)">
        <path
          d="M4.5835 2.91683H5.41683V3.75016H4.5835V2.91683ZM4.5835 4.5835H5.41683V7.0835H4.5835V4.5835ZM5.00016 0.833496C2.70016 0.833496 0.833496 2.70016 0.833496 5.00016C0.833496 7.30016 2.70016 9.16683 5.00016 9.16683C7.30016 9.16683 9.16683 7.30016 9.16683 5.00016C9.16683 2.70016 7.30016 0.833496 5.00016 0.833496ZM5.00016 8.75016C3.16266 8.75016 1.25016 6.83766 1.25016 5.00016C1.25016 3.16266 3.16266 1.25016 5.00016 1.25016C6.83766 1.25016 8.75016 3.16266 8.75016 5.00016C8.75016 6.83766 6.83766 8.75016 5.00016 8.75016Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4480_10718">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  Stepd: ({ size = 30 }) => (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6156 2.2C17.6156 1.61652 17.8474 1.05695 18.26 0.644365C18.6726 0.231785 19.2321 0 19.8156 0H26.4156C26.9991 0 27.5587 0.231785 27.9713 0.644365C28.3838 1.05695 28.6156 1.61652 28.6156 2.2V11H26.4156V2.2H19.8156V8.8C19.8156 9.38348 19.5838 9.94305 19.1713 10.3556C18.7587 10.7682 18.1991 11 17.6156 11H11.0156V17.6C11.0156 18.1835 10.7838 18.7431 10.3713 19.1556C9.95868 19.5682 9.3991 19.8 8.81563 19.8H2.21563V26.4H11.0156V28.6H2.21563C1.63215 28.6 1.07257 28.3682 0.65999 27.9556C0.24741 27.5431 0.015625 26.9835 0.015625 26.4V19.8C0.015625 19.2165 0.24741 18.6569 0.65999 18.2444C1.07257 17.8318 1.63215 17.6 2.21563 17.6H8.81563V11C8.81563 10.4165 9.04741 9.85695 9.45999 9.44437C9.87257 9.03179 10.4321 8.8 11.0156 8.8H17.6156V2.2ZM24.2156 13.2C23.6321 13.2 23.0726 13.4318 22.66 13.8444C22.2474 14.2569 22.0156 14.8165 22.0156 15.4V22H15.4156C14.8321 22 14.2726 22.2318 13.86 22.6444C13.4474 23.0569 13.2156 23.6165 13.2156 24.2V30.8C13.2156 31.3835 13.4474 31.9431 13.86 32.3556C14.2726 32.7682 14.8321 33 15.4156 33H27.5156C28.9743 33 30.3733 32.4205 31.4047 31.3891C32.4362 30.3576 33.0156 28.9587 33.0156 27.5V15.4C33.0156 14.8165 32.7838 14.2569 32.3713 13.8444C31.9587 13.4318 31.3991 13.2 30.8156 13.2H24.2156ZM24.2156 15.4H30.8156V27.5C30.8156 28.3752 30.4679 29.2146 29.8491 29.8335C29.2302 30.4523 28.3908 30.8 27.5156 30.8H15.4156V24.2H22.0156C22.5991 24.2 23.1587 23.9682 23.5713 23.5556C23.9838 23.1431 24.2156 22.5835 24.2156 22V15.4Z"
        fill="black"
      />
    </svg>
  ),

  Light: ({ size = 44 }) => (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.57812 27.5H13.0781C13.0781 29.0125 11.8406 30.25 10.3281 30.25C8.81562 30.25 7.57812 29.0125 7.57812 27.5ZM4.82812 26.125H15.8281V23.375H4.82812V26.125ZM20.6406 13.0625C20.6406 18.315 16.9831 21.12 15.4569 22H5.19937C3.67312 21.12 0.015625 18.315 0.015625 13.0625C0.015625 7.37 4.63563 2.75 10.3281 2.75C16.0206 2.75 20.6406 7.37 20.6406 13.0625ZM17.8906 13.0625C17.8906 8.89625 14.4944 5.5 10.3281 5.5C6.16188 5.5 2.76562 8.89625 2.76562 13.0625C2.76562 16.4588 4.81437 18.4112 5.99687 19.25H14.6594C15.8419 18.4112 17.8906 16.4588 17.8906 13.0625ZM27.3369 10.1337L25.4531 11L27.3369 11.8663L28.2031 13.75L29.0694 11.8663L30.9531 11L29.0694 10.1337L28.2031 8.25L27.3369 10.1337ZM24.0781 8.25L25.3706 5.4175L28.2031 4.125L25.3706 2.8325L24.0781 0L22.7856 2.8325L19.9531 4.125L22.7856 5.4175L24.0781 8.25Z"
        fill="black"
      />
    </svg>
  ),
  Person: ({ size = 30 }) => (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9235 14.6896C15.7336 12.6326 13.9 11.1576 11.7602 10.4584C12.8186 9.82826 13.641 8.86812 14.101 7.7254C14.5609 6.58268 14.6331 5.32056 14.3063 4.13287C13.9796 2.94518 13.272 1.89759 12.2922 1.15097C11.3124 0.404356 10.1147 0 8.88284 0C7.65102 0 6.45325 0.404356 5.47349 1.15097C4.49372 1.89759 3.78612 2.94518 3.45936 4.13287C3.1326 5.32056 3.20474 6.58268 3.66471 7.7254C4.12467 8.86812 4.94703 9.82826 6.0055 10.4584C3.86565 11.1568 2.03206 12.6318 0.842216 14.6896C0.798582 14.7608 0.76964 14.8399 0.757098 14.9225C0.744555 15.005 0.748666 15.0892 0.769188 15.1701C0.78971 15.251 0.826227 15.3269 0.876585 15.3935C0.926942 15.46 0.99012 15.5158 1.06239 15.5576C1.13466 15.5993 1.21456 15.6262 1.29738 15.6365C1.38019 15.6469 1.46425 15.6406 1.54458 15.6179C1.62491 15.5953 1.69989 15.5568 1.7651 15.5047C1.83031 15.4526 1.88442 15.388 1.92425 15.3146C3.39612 12.7709 5.99768 11.2521 8.88284 11.2521C11.768 11.2521 14.3696 12.7709 15.8414 15.3146C15.8813 15.388 15.9354 15.4526 16.0006 15.5047C16.0658 15.5568 16.1408 15.5953 16.2211 15.6179C16.3014 15.6406 16.3855 15.6469 16.4683 15.6365C16.5511 15.6262 16.631 15.5993 16.7033 15.5576C16.7756 15.5158 16.8387 15.46 16.8891 15.3935C16.9395 15.3269 16.976 15.251 16.9965 15.1701C17.017 15.0892 17.0211 15.005 17.0086 14.9225C16.996 14.8399 16.9671 14.7608 16.9235 14.6896ZM4.50784 5.62713C4.50784 4.76183 4.76443 3.91597 5.24516 3.19651C5.72589 2.47704 6.40917 1.91629 7.2086 1.58515C8.00803 1.25402 8.88769 1.16738 9.73636 1.33619C10.585 1.505 11.3646 1.92168 11.9764 2.53353C12.5883 3.14539 13.005 3.92494 13.1738 4.77361C13.3426 5.62227 13.2559 6.50194 12.9248 7.30137C12.5937 8.10079 12.0329 8.78407 11.3135 9.26481C10.594 9.74554 9.74813 10.0021 8.88284 10.0021C7.7229 10.0009 6.61082 9.53955 5.79062 8.71935C4.97042 7.89914 4.50908 6.78707 4.50784 5.62713Z"
        fill="#ED7D2D"
      />
    </svg>
  ),

  Reward: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className="str"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12.25C12.8995 12.25 15.25 9.8995 15.25 7C15.25 4.10051 12.8995 1.75 10 1.75C7.10051 1.75 4.75 4.10051 4.75 7C4.75 9.8995 7.10051 12.25 10 12.25Z"
        stroke="#ED7D2D"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.1575 11.4177L6.25 18.2502L10 16.0002L13.75 18.2502L12.8425 11.4102"
        stroke="#ED7D2D"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  Filev: ({ size = 30 }) => (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5672 4.55781L9.19219 0.182813C9.1341 0.124791 9.06515 0.0787825 8.98928 0.0474149C8.91341 0.0160474 8.8321 -6.43662e-05 8.75 1.93249e-07L1.25 1.93249e-07C0.918479 1.93249e-07 0.600537 0.131696 0.366116 0.366117C0.131696 0.600537 0 0.91848 0 1.25L0 15C0 15.3315 0.131696 15.6495 0.366116 15.8839C0.600537 16.1183 0.918479 16.25 1.25 16.25L12.5 16.25C12.8315 16.25 13.1495 16.1183 13.3839 15.8839C13.6183 15.6495 13.75 15.3315 13.75 15L13.75 5C13.7501 4.9179 13.734 4.83659 13.7026 4.76072C13.6712 4.68485 13.6252 4.6159 13.5672 4.55781ZM9.375 2.13359L11.6164 4.375H9.375L9.375 2.13359ZM12.5 15L1.25 15L1.25 1.25L8.125 1.25L8.125 5C8.125 5.16576 8.19085 5.32473 8.30806 5.44194C8.42527 5.55915 8.58424 5.625 8.75 5.625L12.5 5.625L12.5 15Z"
        fill="#ED7D2D"
      />
    </svg>
  ),

  chkbuilding: ({ size = 30 }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM4 8.236V9H20V8.236L12 4.236L4 8.236ZM12 8C11.7348 8 11.4804 7.89464 11.2929 7.70711C11.1054 7.51957 11 7.26522 11 7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7C13 7.26522 12.8946 7.51957 12.7071 7.70711C12.5196 7.89464 12.2652 8 12 8Z"
        fill="none"
      />
    </svg>
  ),

  chkDirectDebit: ({ size = 30 }) => (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.71858 0C5.2094 0 4.72108 0.210714 4.36104 0.585786C4.001 0.960859 3.79873 1.46957 3.79873 2V6H5.71858V2H13.398V5H10.9982L14.3579 8.5L17.7177 5H15.3178V2C15.3178 1.46957 15.1156 0.960859 14.7555 0.585786C14.3955 0.210714 13.9072 0 13.398 0H5.71858ZM0.918945 8V10H8.59836V8H0.918945ZM0.918945 11V13H8.59836V11H0.918945ZM10.5182 11V13H18.1976V11H10.5182ZM0.918945 14V16H8.59836V14H0.918945ZM10.5182 14V16H18.1976V14H10.5182Z"
        fill="#F18760"
      />
    </svg>
  ),

  chkTransfer: ({ size = 30 }) => (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.918945 18H20.1175V20H0.918945V18ZM2.8388 10H4.75865V17H2.8388V10ZM7.63843 10H9.55829V17H7.63843V10ZM11.4781 10H13.398V17H11.4781V10ZM16.2778 10H18.1976V17H16.2778V10ZM0.918945 5L10.5182 0L20.1175 5V9H0.918945V5ZM2.8388 6.236V7H18.1976V6.236L10.5182 2.236L2.8388 6.236ZM10.5182 6C10.2636 6 10.0195 5.89464 9.83945 5.70711C9.65942 5.51957 9.55829 5.26522 9.55829 5C9.55829 4.73478 9.65942 4.48043 9.83945 4.29289C10.0195 4.10536 10.2636 4 10.5182 4C10.7728 4 11.017 4.10536 11.197 4.29289C11.377 4.48043 11.4781 4.73478 11.4781 5C11.4781 5.26522 11.377 5.51957 11.197 5.70711C11.017 5.89464 10.7728 6 10.5182 6Z"
        fill="#F18760"
      />
    </svg>
  ),

  NextSteps: ({ size = 30 }) => (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1982 1.33333C11.1982 0.979711 11.3331 0.640573 11.5731 0.390524C11.8131 0.140476 12.1387 0 12.4781 0H16.3178C16.6573 0 16.9828 0.140476 17.2228 0.390524C17.4629 0.640573 17.5977 0.979711 17.5977 1.33333V6.66667H16.3178V1.33333H12.4781V5.33333C12.4781 5.68696 12.3433 6.02609 12.1032 6.27614C11.8632 6.52619 11.5377 6.66667 11.1982 6.66667H7.3585V10.6667C7.3585 11.0203 7.22365 11.3594 6.98362 11.6095C6.7436 11.8595 6.41805 12 6.0786 12H2.23889V16H7.3585V17.3333H2.23889C1.89944 17.3333 1.57389 17.1929 1.33386 16.9428C1.09383 16.6928 0.958984 16.3536 0.958984 16V12C0.958984 11.6464 1.09383 11.3072 1.33386 11.0572C1.57389 10.8071 1.89944 10.6667 2.23889 10.6667H6.0786V6.66667C6.0786 6.31305 6.21344 5.97391 6.45347 5.72386C6.6935 5.47381 7.01905 5.33333 7.3585 5.33333H11.1982V1.33333ZM15.0379 8C14.6985 8 14.3729 8.14048 14.1329 8.39052C13.8929 8.64057 13.758 8.97971 13.758 9.33333V13.3333H9.9183C9.57885 13.3333 9.2533 13.4738 9.01328 13.7239C8.77325 13.9739 8.6384 14.313 8.6384 14.6667V18.6667C8.6384 19.0203 8.77325 19.3594 9.01328 19.6095C9.2533 19.8595 9.57885 20 9.9183 20H16.9578C17.8064 20 18.6203 19.6488 19.2203 19.0237C19.8204 18.3986 20.1575 17.5507 20.1575 16.6667V9.33333C20.1575 8.97971 20.0227 8.64057 19.7827 8.39052C19.5426 8.14048 19.2171 8 18.8776 8H15.0379ZM15.0379 9.33333H18.8776V16.6667C18.8776 17.1971 18.6754 17.7058 18.3153 18.0809C17.9553 18.456 17.4669 18.6667 16.9578 18.6667H9.9183V14.6667H13.758C14.0975 14.6667 14.423 14.5262 14.663 14.2761C14.9031 14.0261 15.0379 13.687 15.0379 13.3333V9.33333Z"
        fill="#F18760"
      />
    </svg>
  ),

  chkQuestions: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5835 19.4129V16.4129C5.4085 16.1962 2.0835 12.7296 2.0835 8.50456C2.0835 4.13789 5.6335 0.587891 10.0002 0.587891C14.3668 0.587891 17.9168 4.13789 17.9168 8.50456C17.9168 12.6296 15.0502 16.7796 10.7752 18.8379L9.5835 19.4129ZM10.0002 2.25456C6.55016 2.25456 3.75016 5.05456 3.75016 8.50456C3.75016 11.9546 6.55016 14.7546 10.0002 14.7546H11.2502V16.6712C14.2835 14.7546 16.2502 11.6046 16.2502 8.50456C16.2502 5.05456 13.4502 2.25456 10.0002 2.25456ZM9.16683 11.8379H10.8335V13.5046H9.16683V11.8379ZM10.8335 10.5879H9.16683C9.16683 7.87956 11.6668 8.08789 11.6668 6.42122C11.6668 5.50456 10.9168 4.75456 10.0002 4.75456C9.0835 4.75456 8.3335 5.50456 8.3335 6.42122H6.66683C6.66683 4.57956 8.1585 3.08789 10.0002 3.08789C11.8418 3.08789 13.3335 4.57956 13.3335 6.42122C13.3335 8.50456 10.8335 8.71289 10.8335 10.5879Z"
        fill="#F18760"
      />
    </svg>
  ),

  chkbell: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0002 18.125C10.9169 18.125 11.6669 17.375 11.6669 16.4583H8.33356C8.33356 17.375 9.08356 18.125 10.0002 18.125ZM15.0002 13.125V8.95833C15.0002 6.4 13.6419 4.25833 11.2502 3.69167V3.125C11.2502 2.43333 10.6919 1.875 10.0002 1.875C9.30856 1.875 8.75023 2.43333 8.75023 3.125V3.69167C6.36689 4.25833 5.00023 6.39167 5.00023 8.95833V13.125L3.33356 14.7917V15.625H16.6669V14.7917L15.0002 13.125ZM13.3336 13.9583H6.66689V8.95833C6.66689 6.89167 7.92523 5.20833 10.0002 5.20833C12.0752 5.20833 13.3336 6.89167 13.3336 8.95833V13.9583ZM6.31689 3.19167L5.12523 2C3.12523 3.525 1.80856 5.875 1.69189 8.54167H3.35856C3.48356 6.33333 4.61689 4.4 6.31689 3.19167ZM16.6419 8.54167H18.3086C18.1836 5.875 16.8669 3.525 14.8752 2L13.6919 3.19167C15.3752 4.4 16.5169 6.33333 16.6419 8.54167Z"
        fill="#181819"
      />
    </svg>
  ),

  chkDebit: ({ size = 30 }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6V10H8V6H16V9H13.5L17 12.5L20.5 9H18V6C18 5.46957 17.7893 4.96086 17.4142 4.58579C17.0391 4.21071 16.5304 4 16 4H8ZM3 12V14H11V12H3ZM3 15V17H11V15H3ZM13 15V17H21V15H13ZM3 18V20H11V18H3ZM13 18V20H21V18H13Z"
        fill="black"
      />
    </svg>
  ),

  chkinvestv: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8571 2H10C9.69699 2.0003 9.40647 2.12081 9.19221 2.33507C8.97795 2.54933 8.85745 2.83985 8.85714 3.14286V8.85714H3.14286C2.83985 8.85745 2.54933 8.97795 2.33507 9.19221C2.12081 9.40647 2.0003 9.69699 2 10V18H18V3.14286C17.9997 2.83985 17.8792 2.54933 17.6649 2.33507C17.4507 2.12081 17.1602 2.0003 16.8571 2ZM6 16.8571V12.8571H8.28571V16.8571H6ZM16.8571 16.8571H9.42857V12.2857C9.42857 12.1342 9.36837 11.9888 9.2612 11.8817C9.15404 11.7745 9.0087 11.7143 8.85714 11.7143H5.42857C5.27702 11.7143 5.13167 11.7745 5.02451 11.8817C4.91735 11.9888 4.85714 12.1342 4.85714 12.2857V16.8571H3.14286V10H10V3.14286H16.8571V16.8571Z"
        fill="#ED7D2D"
      />
      <path
        d="M11.25 5H12.5V6.25H11.25V5ZM15 5H16.25V6.25H15V5ZM11.25 8.75H12.5V10H11.25V8.75ZM15 8.75H16.25V10H15V8.75ZM11.25 12.5H12.5V13.75H11.25V12.5ZM15 12.5H16.25V13.75H15V12.5Z"
        fill="#ED7D2D"
      />
    </svg>
  ),

  chkdownload: ({ size = 30 }) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6673 6.8335H10.0007V2.8335H6.00065V6.8335H3.33398L8.00065 11.5002L12.6673 6.8335ZM7.33398 8.16683V4.16683H8.66732V8.16683H9.44732L8.00065 9.6135L6.55398 8.16683H7.33398ZM3.33398 12.8335H12.6673V14.1668H3.33398V12.8335Z"
        fill="black"
      />
    </svg>
  ),

  chkPending: ({ size = 30 }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99984 15.0832C11.9119 15.0832 15.0832 11.9119 15.0832 7.99984C15.0832 4.08782 11.9119 0.916504 7.99984 0.916504C4.08782 0.916504 0.916504 4.08782 0.916504 7.99984C0.916504 11.9119 4.08782 15.0832 7.99984 15.0832Z"
        stroke="#F08913"
      />
      <path
        d="M11.75 7.99967H8.20833C8.15308 7.99967 8.10009 7.97773 8.06102 7.93866C8.02195 7.89959 8 7.84659 8 7.79134V5.08301"
        stroke="#F08913"
        stroke-linecap="round"
      />
    </svg>
  ),

  Chkpaymant: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="str"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.833008V19.1663"
        stroke="#ED7D2D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1667 4.16699H7.91667C7.14312 4.16699 6.40125 4.47428 5.85427 5.02126C5.30729 5.56825 5 6.31011 5 7.08366C5 7.85721 5.30729 8.59907 5.85427 9.14605C6.40125 9.69303 7.14312 10.0003 7.91667 10.0003H12.0833C12.8569 10.0003 13.5987 10.3076 14.1457 10.8546C14.6927 11.4016 15 12.1434 15 12.917C15 13.6905 14.6927 14.4324 14.1457 14.9794C13.5987 15.5264 12.8569 15.8337 12.0833 15.8337H5"
        stroke="#ED7D2D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  Confirmchkflow: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="str"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3327 9.23355V10.0002C18.3317 11.7972 17.7498 13.5458 16.6738 14.9851C15.5978 16.4244 14.0854 17.4773 12.3621 17.9868C10.6389 18.4963 8.79707 18.4351 7.11141 17.8124C5.42575 17.1896 3.98656 16.0386 3.00848 14.5311C2.0304 13.0236 1.56584 11.2403 1.68408 9.44714C1.80232 7.65402 2.49702 5.94715 3.66458 4.58111C4.83214 3.21506 6.41 2.26303 8.16284 1.867C9.91568 1.47097 11.7496 1.65216 13.391 2.38355"
        stroke="#ED7D2D"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 3.33301L10 11.6747L7.5 9.17467"
        stroke="#ED7D2D"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  chkPlus: ({ size = 30 }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="black" />
    </svg>
  ),

  infochkflow: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 17.0837C13.9123 17.0837 17.0837 13.9123 17.0837 10.0003C17.0837 6.08831 13.9123 2.91699 10.0003 2.91699C6.08831 2.91699 2.91699 6.08831 2.91699 10.0003C2.91699 13.9123 6.08831 17.0837 10.0003 17.0837Z"
        stroke="#F08913"
      />
      <path
        d="M13.75 10.0007H10.2083C10.1531 10.0007 10.1001 9.9787 10.061 9.93963C10.0219 9.90056 10 9.84757 10 9.79232V7.08398"
        stroke="#F08913"
        stroke-linecap="round"
      />
    </svg>
  ),

  chkInfo: ({ size = 30 }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill="black"
      />
    </svg>
  ),

  ast: ({ size = 30 }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.3275L12.635 15.125L11.405 9.8525L15.5 6.305L10.1075 5.8475L8 0.875L5.8925 5.8475L0.5 6.305L4.595 9.8525L3.365 15.125L8 12.3275Z"
        fill="none"
      />
    </svg>
  ),

  closeModal: ({ size = 30 }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5827 1.94419L14.0552 0.416687L7.99935 6.47252L1.94352 0.416687L0.416016 1.94419L6.47185 8.00002L0.416016 14.0559L1.94352 15.5834L7.99935 9.52752L14.0552 15.5834L15.5827 14.0559L9.52685 8.00002L15.5827 1.94419Z"
        fill="black"
      />
    </svg>
  ),

  infochkflowRed: ({ size = 30 }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill="#F02113"
      />
    </svg>
  ),

  Helpchkflow: ({ size = 30 }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
        fill="black"
      />
    </svg>
  ),

  CheckRound: ({ size = 30 }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3994_4932)">
        <path
          d="M4 7.5L7 10L11 5M7.5 14.5C6.58075 14.5 5.6705 14.3189 4.82122 13.9672C3.97194 13.6154 3.20026 13.0998 2.55025 12.4497C1.90024 11.7997 1.38463 11.0281 1.03284 10.1788C0.68106 9.32951 0.5 8.41925 0.5 7.5C0.5 6.58075 0.68106 5.6705 1.03284 4.82122C1.38463 3.97194 1.90024 3.20026 2.55025 2.55025C3.20026 1.90024 3.97194 1.38463 4.82122 1.03284C5.6705 0.68106 6.58075 0.5 7.5 0.5C9.35652 0.5 11.137 1.2375 12.4497 2.55025C13.7625 3.86301 14.5 5.64348 14.5 7.5C14.5 9.35652 13.7625 11.137 12.4497 12.4497C11.137 13.7625 9.35652 14.5 7.5 14.5Z"
          stroke="#0DA941"
        />
      </g>
      <defs>
        <clipPath id="clip0_3994_4932">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  ArrowLeft: ({ size = 30 }) => (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z"
        fill="black"
      />
    </svg>
  ),

  Start: ({ size = 30 }) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 18"
      className="slr"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3538 7.8311L2.07294 0.203792C1.86589 0.0750721 1.62875 0.00480123 1.38601 0.000237409C1.14326 -0.00432641 0.90372 0.0569822 0.692118 0.177831C0.48253 0.296804 0.307938 0.470306 0.186295 0.680496C0.0646529 0.890686 0.000350199 1.12998 0 1.37376L0 16.6267C0.00157923 16.9923 0.146123 17.3424 0.401858 17.6C0.657592 17.8575 1.00358 18.0014 1.36378 18C1.61518 17.9999 1.86171 17.9295 2.07635 17.7966L14.3538 10.1693C14.5511 10.0472 14.7142 9.8756 14.8274 9.67101C14.9406 9.46642 15 9.23572 15 9.00108C15 8.76643 14.9406 8.53573 14.8274 8.33114C14.7142 8.12656 14.5511 7.95496 14.3538 7.83284V7.8311ZM1.36378 16.6102L1.36378 1.38501L13.6233 9.00021L1.36378 16.6102Z"
        fill="#ED7D2D"
      />
    </svg>
  ),

  SignOut: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 32 32">
      <g id="Sign_Out">
        <path
          d="M15,30H2V2h13c0.552,0,1-0.448,1-1s-0.448-1-1-1H1C0.448,0,0,0.448,0,1v30c0,0.552,0.448,1,1,1h14   c0.552,0,1-0.448,1-1S15.552,30,15,30z"
          fill="#121313"
        />
        <path d="M31.71,15.302l-6.9-6.999c-0.391-0.395-1.024-0.394-1.414,0c-0.391,0.394-0.391,1.034,0,1.428l5.2,5.275   H8.003c-0.552,0-1,0.452-1,1.01c0,0.558,0.448,1.01,1,1.01h20.593l-5.2,5.275c-0.391,0.395-0.391,1.034,0,1.428   c0.391,0.395,1.024,0.395,1.414,0l6.899-6.999C32.095,16.341,32.099,15.69,31.71,15.302z" />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),

  Offer: ({ size = 18 }) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="str"
    >
      <path
        d="M15.666 4.83301H2.33268C1.41221 4.83301 0.666016 5.5792 0.666016 6.49967V14.833C0.666016 15.7535 1.41221 16.4997 2.33268 16.4997H15.666C16.5865 16.4997 17.3327 15.7535 17.3327 14.833V6.49967C17.3327 5.5792 16.5865 4.83301 15.666 4.83301Z"
        stroke="#ED7D2D"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3327 16.5V3.16667C12.3327 2.72464 12.1571 2.30072 11.8445 1.98816C11.532 1.67559 11.108 1.5 10.666 1.5H7.33268C6.89065 1.5 6.46673 1.67559 6.15417 1.98816C5.84161 2.30072 5.66602 2.72464 5.66602 3.16667V16.5"
        stroke="#ED7D2D"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  UploadFile: ({ size = 18 }) => (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9997 15.4997V19.4997H2.99967V15.4997H0.333008V19.4997C0.333008 20.9663 1.53301 22.1663 2.99967 22.1663H18.9997C20.4663 22.1663 21.6663 20.9663 21.6663 19.4997V15.4997H18.9997ZM4.33301 7.49967L6.21301 9.37967L9.66634 5.93967V16.833H12.333V5.93967L15.7863 9.37967L17.6663 7.49967L10.9997 0.833008L4.33301 7.49967Z"
        fill="#000"
      />
    </svg>
  ),
  Upload: ({ size = 18 }) => (
    <svg
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points="16 16 12 12 8 16" />
      <line x1="12" x2="12" y1="12" y2="21" />
      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
      <polyline points="16 16 12 12 8 16" />
    </svg>
  ),
  Cancel: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 50 50">
      <g id="Layer_1">
        <path d="M28,2h-9v2h9c10.477,0,19,8.523,19,19s-8.523,19-19,19H5.414l3.293-3.293l-1.414-1.414L1.586,43l5.707,5.707l1.414-1.414   L5.414,44H28c11.58,0,21-9.421,21-21S39.58,2,28,2z" />
        <rect height="2" width="3" x="13" y="2" />
        <rect height="2" width="3" x="7" y="2" />
        <rect height="2" width="3" x="1" y="2" />
      </g>
      <g />
    </svg>
  ),
  User: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 50 50">
      <g id="Layer_1">
        <path d="M25,1C11.767,1,1,11.767,1,25c0,7.091,3.094,13.472,8,17.869v0.017l0.348,0.3c0.061,0.053,0.128,0.097,0.19,0.149   c0.431,0.364,0.875,0.713,1.331,1.047c0.123,0.09,0.246,0.177,0.371,0.264c0.484,0.34,0.979,0.664,1.487,0.968   c0.085,0.051,0.172,0.099,0.257,0.148c0.557,0.324,1.126,0.629,1.71,0.908c0.006,0.003,0.012,0.005,0.018,0.008   c1.249,0.595,2.559,1.082,3.915,1.456c0.025,0.007,0.05,0.015,0.075,0.021c0.641,0.175,1.293,0.322,1.954,0.443   c0.062,0.011,0.123,0.022,0.185,0.033c0.638,0.112,1.284,0.201,1.939,0.262c0.075,0.007,0.15,0.011,0.224,0.017   C23.663,48.965,24.327,49,25,49s1.337-0.035,1.996-0.09c0.075-0.006,0.15-0.01,0.224-0.017c0.655-0.06,1.301-0.15,1.939-0.262   c0.062-0.011,0.123-0.022,0.185-0.033c0.661-0.121,1.313-0.268,1.954-0.443c0.025-0.007,0.05-0.014,0.075-0.021   c1.356-0.374,2.666-0.861,3.915-1.456c0.006-0.003,0.012-0.005,0.018-0.008c0.584-0.279,1.153-0.585,1.71-0.908   c0.086-0.05,0.172-0.097,0.257-0.148c0.509-0.304,1.004-0.629,1.487-0.968c0.124-0.087,0.248-0.174,0.371-0.264   c0.456-0.334,0.9-0.683,1.331-1.047c0.062-0.052,0.129-0.096,0.19-0.149l0.348-0.3v-0.017c4.906-4.398,8-10.778,8-17.869   C49,11.767,38.233,1,25,1z M25,25c-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S29.411,25,25,25z M28,27c6.065,0,11,4.935,11,11   v3.958c-0.042,0.035-0.086,0.067-0.128,0.102c-0.395,0.321-0.8,0.626-1.214,0.918c-0.092,0.065-0.182,0.132-0.274,0.195   c-0.447,0.305-0.906,0.591-1.373,0.862c-0.085,0.05-0.171,0.099-0.257,0.148c-0.49,0.275-0.989,0.533-1.498,0.769   c-0.053,0.025-0.107,0.049-0.161,0.073c-1.661,0.755-3.411,1.302-5.212,1.626c-0.057,0.01-0.114,0.021-0.171,0.031   c-0.567,0.097-1.139,0.172-1.715,0.225c-0.079,0.007-0.159,0.012-0.239,0.018C26.175,46.97,25.589,47,25,47   s-1.175-0.03-1.758-0.077c-0.079-0.006-0.159-0.011-0.239-0.018c-0.576-0.053-1.148-0.127-1.715-0.225   c-0.057-0.01-0.114-0.02-0.171-0.031c-1.801-0.324-3.551-0.871-5.212-1.626c-0.054-0.025-0.108-0.048-0.161-0.073   c-0.509-0.236-1.008-0.494-1.498-0.769c-0.086-0.049-0.171-0.098-0.257-0.148c-0.467-0.27-0.926-0.557-1.373-0.862   c-0.093-0.063-0.183-0.13-0.274-0.195c-0.414-0.292-0.819-0.596-1.214-0.918c-0.042-0.034-0.086-0.067-0.128-0.102V38   c0-6.065,4.935-11,11-11H28z M41,40.076V38c0-6.271-4.464-11.519-10.38-12.735C33.261,23.464,35,20.431,35,17   c0-5.514-4.486-10-10-10s-10,4.486-10,10c0,3.431,1.739,6.464,4.38,8.265C13.464,26.481,9,31.729,9,38v2.076   C5.284,36.135,3,30.831,3,25C3,12.869,12.869,3,25,3s22,9.869,22,22C47,30.831,44.716,36.135,41,40.076z" />
      </g>
      <g />
    </svg>
  ),
  Admin: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 50 50">
      <g id="Layer_1">
        <path d="M5,32v17h30.343l2.167-1.686C42.27,43.612,45,38.03,45,32v-0.649l-8.841-3.931c-1.59-4.225-5.229-7.262-9.55-8.147   C29.257,17.472,31,14.436,31,11c0-5.514-4.486-10-10-10S11,5.486,11,11c0,3.431,1.739,6.464,4.38,8.265C9.464,20.481,5,25.729,5,32   z M42.988,32.645c-0.187,5.16-2.607,9.903-6.707,13.092L35,46.733l-1.281-0.997c-4.1-3.188-6.521-7.932-6.707-13.092l7.99-3.55   L42.988,32.645z M13,11c0-4.411,3.589-8,8-8s8,3.589,8,8s-3.589,8-8,8S13,15.411,13,11z M18,21h6c4.312,0,8.173,2.517,9.961,6.367   L25,31.351V32c0,5.865,2.589,11.3,7.109,15H7V32C7,25.935,11.935,21,18,21z" />
        <polygon points="36,33 34,33 34,36 31,36 31,38 34,38 34,41 36,41 36,38 39,38 39,36 36,36  " />
      </g>
      <g />
    </svg>
  ),
  Dash: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 48 48">
      <g id="Expanded">
        <g>
          <g>
            <path d="M24,48C10.767,48,0,37.233,0,24S10.767,0,24,0s24,10.767,24,24S37.233,48,24,48z M24,2C11.869,2,2,11.869,2,24     s9.869,22,22,22s22-9.869,22-22S36.131,2,24,2z" />
          </g>
          <g>
            <path d="M24,28c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S26.206,28,24,28z M24,22c-1.103,0-2,0.897-2,2s0.897,2,2,2     s2-0.897,2-2S25.103,22,24,22z" />
          </g>
          <g>
            <path d="M26.122,22.879c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l9.899-9.899     c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-9.899,9.899C26.633,22.781,26.377,22.879,26.122,22.879z" />
          </g>
          <g>
            <path d="M9,25H5c-0.552,0-1-0.447-1-1s0.448-1,1-1h4c0.552,0,1,0.447,1,1S9.552,25,9,25z" />
          </g>
          <g>
            <path d="M6.447,32.271c-0.393,0-0.765-0.232-0.924-0.617c-0.211-0.511,0.031-1.096,0.542-1.307l3.696-1.53     c0.509-0.213,1.095,0.03,1.306,0.541c0.211,0.511-0.031,1.096-0.542,1.307l-3.696,1.53C6.704,32.246,6.574,32.271,6.447,32.271z" />
          </g>
          <g>
            <path d="M41.552,32.271c-0.127,0-0.257-0.024-0.382-0.076l-3.695-1.531c-0.51-0.212-0.752-0.797-0.541-1.307     c0.211-0.511,0.797-0.754,1.307-0.541l3.695,1.531c0.51,0.212,0.752,0.797,0.541,1.307     C42.316,32.039,41.944,32.271,41.552,32.271z" />
          </g>
          <g>
            <path d="M42.999,25.001L42.999,25.001l-4-0.001c-0.552,0-1-0.448-1-1c0-0.553,0.448-1,1-1l0,0l4,0.001c0.553,0,1,0.448,1,1     C43.999,24.554,43.551,25.001,42.999,25.001z" />
          </g>
          <g>
            <path d="M37.858,19.26c-0.393,0-0.765-0.232-0.924-0.617c-0.211-0.511,0.031-1.096,0.542-1.307l3.695-1.529     c0.509-0.211,1.095,0.031,1.306,0.541c0.211,0.511-0.031,1.096-0.542,1.307l-3.695,1.529     C38.115,19.235,37.986,19.26,37.858,19.26z" />
          </g>
          <g>
            <path d="M29.74,11.142c-0.127,0-0.257-0.024-0.382-0.076c-0.51-0.212-0.752-0.797-0.541-1.307l1.531-3.694     c0.211-0.51,0.796-0.752,1.307-0.541c0.51,0.212,0.752,0.797,0.541,1.307l-1.531,3.694C30.504,10.909,30.132,11.142,29.74,11.142     z" />
          </g>
          <g>
            <path d="M24,10L24,10c-0.553,0-1-0.448-1-1l0.001-3.999c0-0.553,0.448-1,1-1l0,0c0.553,0,1,0.448,1,1L25,9     C25,9.553,24.552,10,24,10z" />
          </g>
          <g>
            <path d="M18.26,11.142c-0.393,0-0.765-0.232-0.924-0.617l-1.529-3.695c-0.211-0.511,0.031-1.096,0.542-1.307     c0.51-0.212,1.096,0.031,1.306,0.541l1.529,3.695c0.211,0.511-0.031,1.096-0.542,1.307C18.517,11.117,18.388,11.142,18.26,11.142     z" />
          </g>
          <g>
            <path d="M13.394,14.394c-0.256,0-0.512-0.098-0.708-0.293l-2.827-2.829c-0.39-0.391-0.39-1.024,0-1.414     c0.391-0.391,1.024-0.391,1.415,0l2.827,2.829c0.39,0.391,0.39,1.024,0,1.414C13.905,14.296,13.649,14.394,13.394,14.394z" />
          </g>
          <g>
            <path d="M10.142,19.26c-0.127,0-0.257-0.024-0.383-0.076l-3.695-1.532c-0.51-0.212-0.752-0.797-0.541-1.307     s0.795-0.753,1.307-0.541l3.695,1.532c0.51,0.212,0.752,0.797,0.541,1.307C10.906,19.027,10.534,19.26,10.142,19.26z" />
          </g>
          <g>
            <path d="M33,40H15c-0.552,0-1-0.447-1-1v-6c0-0.553,0.448-1,1-1h18c0.552,0,1,0.447,1,1v6C34,39.553,33.552,40,33,40z M16,38h16     v-4H16V38z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  Id: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 48 48">
      <path d="M43,42H5c-2.209,0-4-1.791-4-4V17c0-2.209,1.791-4,4-4h15V9c0-2.209,1.791-4,4-4  s4,1.791,4,4v4h15c2.209,0,4,1.791,4,4v21C47,40.209,45.209,42,43,42z M17.014,34.488c0,0.003,0,0.004,0,0.004  c-0.004,0-0.018-0.781-0.018-0.781s1.166-0.601,2.031-1.378c0.507-0.417,0.741-1.362,0.741-1.362  c0.137-0.828,0.238-2.877,0.238-3.703c0-2.062-1.033-4.28-4.007-4.28V22.98v0.007c-2.974,0-4.007,2.219-4.007,4.28  c0,0.826,0.102,2.875,0.238,3.703c0,0,0.234,0.945,0.741,1.362c0.865,0.777,2.031,1.378,2.031,1.378s-0.014,0.781-0.018,0.781  c0,0,0-0.001,0-0.004c0,0,0.029,1.146,0.029,1.487c0,1.362-1.365,2.018-2.223,2.018c-0.002,0-0.002,0-0.003,0  c-2.593,0.113-3.205,0.976-3.21,0.984C9.419,39.23,9.199,39.482,8.998,40h14.004c-0.201-0.518-0.421-0.77-0.582-1.022  c-0.005-0.009-0.617-0.871-3.21-0.984c-0.001,0-0.001,0-0.003,0c-0.857,0-2.223-0.655-2.223-2.018  C16.984,35.634,17.014,34.488,17.014,34.488z M26,9c0-1.104-0.896-2-2-2s-2,0.896-2,2v6c0,1.104,0.896,2,2,2s2-0.896,2-2V9z M45,17  c0-1.104-0.896-2-2-2H28c0,2.209-1.791,4-4,4s-4-1.791-4-4H5c-1.104,0-2,0.896-2,2v21c0,1.104,0.896,2,2,2h1.797  c0.231-0.589,0.656-1.549,1.16-2.24c0.025-0.014,0.848-1.739,4.998-1.79c0.006-0.021,0.01-1.042,0.022-1.027  c-0.32-0.202-0.737-0.516-1.051-0.816c-0.255-0.156-1.161-1.029-1.452-2.583c-0.087-0.542-0.488-3.099-0.488-4.166  c0-3.171,1.265-6.381,5.953-6.381c0.021,0,0.1,0,0.121,0c4.688,0,5.953,3.21,5.953,6.381c0,1.067-0.401,3.624-0.488,4.166  c-0.291,1.554-1.197,2.427-1.452,2.583c-0.313,0.301-0.73,0.614-1.051,0.816c0.013-0.015,0.017,1.007,0.022,1.027  c4.151,0.051,4.974,1.776,4.998,1.79c0.504,0.691,0.929,1.651,1.16,2.24H43c1.104,0,2-0.896,2-2V17z M40,26H28c-0.553,0-1-0.447-1-1  s0.447-1,1-1h12c0.553,0,1,0.447,1,1S40.553,26,40,26z M28,30h2c0.553,0,1,0.447,1,1s-0.447,1-1,1h-2c-0.553,0-1-0.447-1-1  S27.447,30,28,30z M28,34h6c0.553,0,1,0.447,1,1s-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1S27.447,34,28,34z M32,31c0-0.553,0.447-1,1-1  h4c0.553,0,1,0.447,1,1s-0.447,1-1,1h-4C32.447,32,32,31.553,32,31z M23,9h2v2h-2V9z" />
    </svg>
  ),
  Chat: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 48 48">
      <path d="M40 4H8C5.79 4 4 5.79 4 8v36l8-8h28c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4z" />
      <path d="M0 0h48v48H0z" fill="none" />
    </svg>
  ),
  Heart: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 512 512">
      <path d="M340.8,83C307,83,276,98.8,256,124.8c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6  L245.1,418l10.9,11l10.9-11l148.3-149.8c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z" />
    </svg>
  ),
  Plus: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24">
      <path d="M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z" />
    </svg>
  ),
  Plusd: ({ size = 18 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17Z"
        fill="#000000"
      />
    </svg>
  ),

  Search: ({ size = 18 }) => (
    <svg width={size} height={size} fill="currentColor" viewBox="0 0 30 30">
      <path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z" />
    </svg>
  ),
  Menu: ({ size = 18 }) => (
    <svg width={size} height={size} stroke="currentColor" viewBox="0 0 32 32">
      <line
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        x1="7"
        x2="25"
        y1="16"
        y2="16"
      />
      <line
        fill="none"
        id="XMLID_102_"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        x1="7"
        x2="25"
        y1="25"
        y2="25"
      />
      <line
        fill="none"
        id="XMLID_101_"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        x1="7"
        x2="25"
        y1="7"
        y2="7"
      />
    </svg>
  ),

  Reck: ({ size = 30 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1777 14.8809L13.8129 18.7499L20.3563 11.7856"
        stroke="#CC744B"
      />
      <circle cx="15" cy="15" r="14.5" stroke="#CC744B" />
    </svg>
  ),
};

export default Icons;
